/**
 * @deprecated This file is deprecated and will be removed in a future version.
 *
 * All theme values have been migrated to CSS variables in src/global/styles/global.css.
 * For new components, please use shadcn/ui with Tailwind CSS classes instead of MUI.
 *
 * Migration guide:
 * - Primary color (#0C2856): Use `className="bg-primary text-primary-foreground"` or `var(--primary)`
 * - Secondary color (#9FC131): Use `className="bg-secondary text-secondary-foreground"` or `var(--secondary)`
 * - Typography: Use Tailwind text classes like `text-h1`, `text-h2`, `text-body1`, etc.
 * - Spacing: All spacing values are available as CSS variables
 *
 * See tailwind.config.ts and global.css for the complete list of available CSS variables.
 */

import { createTheme } from "@mui/material/styles";

const currentRoute = window.location.pathname;

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#0C2856", // Admin color (greenLight)
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#9FC131", // Public color (dark blue)
      contrastText: "#FFFFFF",
    },
  },
  spacing: 4,
  typography: {
    fontFamily: '"Work Sans", sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: "2rem", // 32px
      lineHeight: 1, // 100%
      letterSpacing: 0,
    },
    // h2 -> Title 2 (32px, 500 weight)
    h2: {
      fontWeight: 500,
      fontSize: "2rem", // 32px
      lineHeight: 1, // 100%
      letterSpacing: 0,
    },
    // h4 (24px, 500 weight, 28px line-height)
    h4: {
      fontWeight: 600,
      fontSize: "1.5rem", // 24px
      lineHeight: "2.8rem", // 28px
      letterSpacing: 0,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.25rem", // 20px
      lineHeight: "1.5rem", // 24px
      letterSpacing: 0,
    },
    // body1 -> body3 from Figma (16px, 400 weight)
    body1: {
      fontWeight: 500,
      fontSize: "1rem", // 16px
      lineHeight: 1, // 100%
      letterSpacing: 0,
    },
    body2: {
      fontWeight: 500,
      fontSize: "1.125rem",
      lineHeight: "2.2rem",
      letterSpacing: 0,
    },
    button: {
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: "2.2rem",
      letterSpacing: 0,
    },
    // subtitle1 -> b2 from Figma (18px, 400 weight, 22px line-height)
    subtitle1: {
      fontWeight: 600,
      fontSize: "1.125rem", // 18px
      lineHeight: "2.2rem", // 22px
      letterSpacing: 0,
      color: "#707070",
    },
    // caption -> b5 from Figma (14px, 400 weight, 18px line-height)
    caption: {
      fontWeight: 400,
      fontSize: "0.875rem", // 14px
      lineHeight: "1.8rem", // 18px
      letterSpacing: 0,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        },
        body: {
          height: "100vh",
          backgroundColor: currentRoute.includes("app/alt-data")
            ? "#292C31"
            : "#EDEDF4",
          color: "#000000",
          fontFamily: '"Work Sans", sans-serif',
          fontSize: "12px",
          textRendering: "optimizeLegibility",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#EDEDED",
          "& .MuiTableCell-root": {
            border: "none",
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            borderLeft: "none",
            borderRight: "none",
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#D9D9D9 !important", // grayPale
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "2px",
            background: "#D9D9D9", // grayPale
            padding: "7px",
          },
          "&.Mui-checked": {
            color: "#0C2856 !important", // greenLight
            "&::before": {
              background: "#0C2856", // greenLight
            },
          },
        },
      },
    },
  },
});
